<template>
  <div class="modal customer-options-modal is-active">
    <div class="modal-background" @click="onClose" />
    <div class="modal-content">
      <div class="modal-header is-flex is-justify-content-space-between is-align-items-center">
        <p class="title mb-0">{{ title }}</p>
        <button type="button" class="delete" @click="onClose" />
      </div>
      <div class="modal-body">
        <p v-if="message" class="description">{{ message }}</p>
        <slot />
      </div>
      <div class="is-flex is-justify-content-flex-end mt-4" style="gap: 8px">
        <button type="button" class="button" @click="onClose">Cancelar</button>
        <button
          type="button"
          class="button is-primary"
          :class="{ 'is-loading': isLoading }"
          :disabled="isLoading"
          @click="$emit('confirm')"
        >
          Confirmar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "Confirmação",
    },
    message: {
      type: String,
      default: "",
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["close", "confirm"],
  methods: {
    onClose() {
      if (this.isLoading) return;
      this.$emit("close");
    },
  },
};
</script>
